(function () {
  var sheet = document.getElementById('makc-filter-sheet');
  if (!sheet) return;

  var panel = sheet.querySelector('[data-makc-filter-sheet-panel]');
  var backdrop = sheet.querySelector('[data-makc-filter-sheet-backdrop]');
  var closeButton = sheet.querySelector('[data-makc-filter-sheet-close]');
  var applyButton = sheet.querySelector('[data-makc-filter-sheet-apply]');
  var handleRow = sheet.querySelector('[data-makc-filter-sheet-handle]');
  var sheetPills = Array.prototype.slice.call(
    sheet.querySelectorAll('[data-makc-filter-sheet-pills] .makc-filter-pill')
  );

  var trigger = document.querySelector('[data-makc-filter-sheet-trigger]');
  var categoryPillsNav = document.querySelector('[data-makc-menu-toolbar-category-pills]');
  var activeFiltersRow = document.querySelector('[data-makc-menu-toolbar-active-filters]');
  var toolbarActivePills = activeFiltersRow
    ? Array.prototype.slice.call(activeFiltersRow.querySelectorAll('.makc-filter-pill'))
    : [];
  var clearAllButton = document.querySelector('[data-makc-filter-clear-all]');
  var emptyState = document.querySelector('[data-makc-menu-grid-empty]');
  var emptyStateClear = document.querySelector('[data-makc-menu-grid-clear]');

  if (!panel || !trigger) return;

  // Matches the 0.2s ease already used consistently for the footer
  // accordion and its other transitions (assets/makc-footer.css), not a
  // new value.
  var TRANSITION_MS = 200;
  var DISMISS_THRESHOLD_RATIO = 0.25;

  // From 768px the sheet is a centred modal, not a bottom sheet (see the
  // 768px block in assets/makc-filter-sheet.css and CLAUDE.md's overlay
  // switch point). Two behaviours change with it: the open/close
  // animation is a fade rather than a slide (sliding a centred modal up
  // from the bottom edge is the sheet's gesture, not a modal's), and
  // drag-to-dismiss is off (no bottom edge to drag from). Read per call,
  // not once at init, so a resize or a rotation mid-session is handled.
  function isModalLayout() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  // Which property carries the open and close. Deliberately NOT folded
  // into isModalLayout(): that one answers "is this a centred modal",
  // which also decides whether drag-to-dismiss is wired, and reduced
  // motion must not disable a real drag (CLAUDE.md "Motion" -- reduced
  // motion is about animation the interface plays, not the customer's
  // own gesture). This answers only "fade rather than slide", and the
  // drag guard keeps asking the layout question.
  //
  // Reduce takes the fade because --makc-sheet-translate is 0px there,
  // so a transform close would animate nothing, fire no transitionend,
  // and leave finish() to its timer -- which is the iOS two-motion
  // close this branch fixes. Read per call, like isModalLayout(), so a
  // mid-session change to either is handled.
  function usesFade() {
    return isModalLayout() || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Both animated properties are cleared together whichever one drove
  // the last open, so a viewport that crosses 768 between opens can
  // never leave the other one set.
  function clearPanelAnimation() {
    panel.style.transform = '';
    panel.style.opacity = '';
  }

  var appliedFilters = new Set();

  // Exposes the current applied-filter state for other modules to
  // read -- specifically assets/makc-search-takeover.js, which
  // intersects search results with the active dietary filter(s), same
  // AND-within-group semantics as applyFiltersToGrid() below. A getter
  // function, not a direct reference, since appliedFilters is
  // REASSIGNED (not mutated) on every Apply/Clear-all -- a plain
  // exported reference would go stale after the first change; this
  // closes over the same variable, so it's always current. Matches
  // the established window.makcScrollLock/window.makcCart convention
  // for cross-file shared state already used throughout this build.
  window.makcFilters = {
    getApplied: function () {
      return appliedFilters;
    }
  };

  // ---- Open / close -------------------------------------------------

  function syncSheetPillsToApplied() {
    sheetPills.forEach(function (pill) {
      var value = pill.getAttribute('data-filter-value');
      pill.setAttribute('aria-pressed', appliedFilters.has(value) ? 'true' : 'false');
    });
  }

  // Scroll-lock lives in the shared assets/makc-scroll-lock.js, loaded
  // once from sections/makc-menu.liquid before this script -- see that
  // file for why it's shared rather than a local implementation here.
  function openSheet() {
    // Reopening always re-syncs to the last-applied state -- this is
    // also what makes closing without Apply a no-op: whatever was
    // tapped in-sheet without being applied just gets overwritten by
    // this sync the next time it opens, no separate "discard" logic
    // needed.
    syncSheetPillsToApplied();
    // Cleared here as well as in finish(): reopening while a close is
    // still running would otherwise leave the backdrop mid-fade-out.
    sheet.classList.remove('makc-filter-sheet--closing');
    sheet.hidden = false;
    window.makcScrollLock.lock();
    // Toggling hidden alone can't animate a display:none element -- the
    // "start" position (off-screen, no transition) has to be set
    // synchronously first, then the transition restored and the target
    // position set on the next frame so the browser actually animates
    // the change instead of coalescing it.
    var fade = usesFade();
    panel.classList.add('makc-filter-sheet__panel--dragging');
    clearPanelAnimation();
    if (fade) {
      panel.style.opacity = '0';
    } else {
      panel.style.transform = 'translateY(var(--makc-sheet-translate))';
    }
    void panel.offsetHeight; // force reflow before restoring the transition
    panel.classList.remove('makc-filter-sheet__panel--dragging');
    requestAnimationFrame(function () {
      if (fade) {
        panel.style.opacity = '1';
      } else {
        panel.style.transform = 'translateY(0)';
      }
    });
  }

  // onClosed (optional) runs AFTER window.makcScrollLock.unlock() below,
  // not before -- required for the Apply handler's own scroll-to-top
  // fix (see its own comment): unlock() restores whatever scroll
  // position was captured when the sheet opened
  // (assets/makc-scroll-lock.js), which fires asynchronously (on
  // transitionend, or the setTimeout fallback below, whichever comes
  // first) -- strictly AFTER anything the click handler itself runs
  // synchronously. A scroll-to-top called directly in the click handler
  // (the original, confirmed-broken approach) always loses this race:
  // it runs first, then gets silently overwritten the moment unlock()
  // fires ~200-250ms later. Passing a callback that runs from inside
  // finish(), after unlock(), is the only ordering that actually wins.
  function closeSheet(onClosed) {
    // Fades the backdrop out alongside the panel's slide (assets/
    // makc-filter-sheet.css). The root's [hidden] is not set until
    // finish(), which is far too late to fade anything.
    sheet.classList.add('makc-filter-sheet--closing');
    // Signals the exit NOW, not at finish(), so the cart pill's own
    // entrance overlaps the panel's slide instead of queueing behind it.
    // Scroll stays locked either way -- unlock() and the position restore
    // are untouched below and still run on the panel's transitionend, so
    // CLAUDE.md's "Scroll position" ordering is unchanged. Guarded
    // because an older cached scroll-lock.js would not have it.
    if (window.makcScrollLock.beginClose) window.makcScrollLock.beginClose();
    if (usesFade()) {
      panel.style.opacity = '0';
    } else {
      panel.style.transform = 'translateY(var(--makc-sheet-translate))';
    }
    var done = false;
    // transitionend bubbles, so a transition ending on any control INSIDE
    // the panel (a pill's colour swap, Apply's or the close X's press
    // scale) would otherwise finish the close early and cut the slide or
    // fade short. Only the panel's own transition counts. The setTimeout
    // fallback below calls finish() with no event, which still passes.
    function finish(event) {
      if (event && event.target !== panel) return;
      if (done) return;
      done = true;
      panel.removeEventListener('transitionend', finish);
      sheet.hidden = true;
      sheet.classList.remove('makc-filter-sheet--closing');
      clearPanelAnimation();
      window.makcScrollLock.unlock();
      if (onClosed) onClosed();
    }
    panel.addEventListener('transitionend', finish);
    setTimeout(finish, TRANSITION_MS + 50);
  }

  trigger.addEventListener('click', openSheet);
  // Wrapped, not passed directly -- closeSheet now takes an optional
  // onClosed callback (see its own comment); passed as a bare event
  // listener, the DOM would invoke it with the click Event itself as
  // that argument, and `if (onClosed) onClosed();` would then try to
  // call the Event object as a function and throw. Plain dismiss (X or
  // backdrop tap) never scrolls to top -- only Apply and Clear-all do.
  if (closeButton) closeButton.addEventListener('click', function () { closeSheet(); });
  if (backdrop) backdrop.addEventListener('click', function () { closeSheet(); });

  // ---- Pill selection (draft -- not applied until Apply is tapped) --

  sheetPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var pressed = pill.getAttribute('aria-pressed') === 'true';
      pill.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    });
  });

  // ---- Apply / clear-all ---------------------------------------------

  function syncToolbarUI() {
    var hasFilters = appliedFilters.size > 0;
    if (categoryPillsNav) categoryPillsNav.hidden = hasFilters;
    if (activeFiltersRow) activeFiltersRow.hidden = !hasFilters;
    toolbarActivePills.forEach(function (pill) {
      var value = pill.getAttribute('data-filter-value');
      pill.hidden = !appliedFilters.has(value);
    });
  }

  // AND logic within the Dietary group: a card is shown only if it
  // carries EVERY applied tag. REVERSED 2026-09-23 -- this was OR
  // ("a card matches if it has ANY of the applied tags"), recorded here
  // as confirmed.
  //
  // Why the reversal: dietary values are constraints, not categories. A
  // customer selecting Vegan and Gluten-free is stating two requirements
  // at once, not browsing two lists. Under OR, adding Gluten-free to
  // Vegan + Vegetarian pulled in every gluten-free dish regardless of
  // whether it was vegan at all -- measured against the live catalogue
  // on 2026-09-23, that combination went from 9 matching cards to 36,
  // and Efo Riro (dairy-free, gluten-free, no vegan or vegetarian tag)
  // reappeared under a Vegan filter purely because it is gluten-free.
  // For a dietary restriction that is not a cosmetic flaw, it is the
  // wrong dish. Under AND the same combination returns 7.
  //
  // Search applies the identical rule in assets/makc-search-takeover.js
  // (passesDietaryFilter) -- the two must not disagree.
  //
  // Hiding a card can hide one that carries a category anchor id (Row
  // 2's category-pill scroll targets, see makc-menu-grid.liquid) --
  // deliberately not handled specially. While any filter is active, Row
  // 2 shows active-filter pills instead of category pills (syncToolbarUI
  // above), so there's no user-facing way to trigger a scroll to a
  // hidden anchor while this matters. Clearing filters restores every
  // card via the appliedFilters.size === 0 branch below, including
  // anchor-bearing ones, so category-pill scrolling is back to normal by
  // the time it's visible again.
  function applyFiltersToGrid() {
    var cards = document.querySelectorAll('.makc-menu-card');
    cards.forEach(function (card) {
      if (appliedFilters.size === 0) {
        card.hidden = false;
        return;
      }
      var cardTags = (card.getAttribute('data-dietary-tags') || '').split(' ').filter(Boolean);
      // Every applied filter must be present on the card. Iterating the
      // applied set, not the card's tags: a card with no tags at all
      // must fail, and Array.every on an empty tag list would return
      // true. The appliedFilters.size === 0 branch above already handles
      // "no filters active".
      var matches = true;
      appliedFilters.forEach(function (tag) {
        if (cardTags.indexOf(tag) === -1) matches = false;
      });
      card.hidden = !matches;
    });
    syncEmptyState(cards);
  }

  // Zero results is an ordinary outcome under AND -- Vegan +
  // Gluten-free + Dairy-free is a reasonable ask that may genuinely
  // match nothing -- where under OR it was almost unreachable. Without
  // this the customer gets a blank page under the toolbar with no
  // explanation and no way back except finding the clear-all X.
  //
  // Counted from the same NodeList applyFiltersToGrid just wrote, not
  // re-queried, so the count cannot disagree with what was painted. The
  // element only exists on the Menu page (see makc-menu-grid.liquid), so
  // the guard also keeps this inert everywhere else.
  function syncEmptyState(cards) {
    if (!emptyState) return;
    var anyVisible = false;
    Array.prototype.forEach.call(cards, function (card) {
      if (!card.hidden) anyVisible = true;
    });
    emptyState.hidden = anyVisible || appliedFilters.size === 0;
  }

  if (applyButton) {
    applyButton.addEventListener('click', function () {
      appliedFilters = new Set(
        sheetPills
          .filter(function (pill) {
            return pill.getAttribute('aria-pressed') === 'true';
          })
          .map(function (pill) {
            return pill.getAttribute('data-filter-value');
          })
      );
      syncToolbarUI();
      applyFiltersToGrid();
      // Confirmed bug, not a hypothetical: applyFiltersToGrid() above
      // hides non-matching cards synchronously, which can shrink the
      // page well below wherever the user was scrolled to before
      // opening the sheet. The browser's own scroll-bounds clamping
      // (snapping an out-of-range scrollTop down to the new, shorter
      // max) was producing the "landed somewhere unexpected" symptom on
      // its own, not a bug in the filtering logic itself.
      //
      // A previous fix called window.scrollTo(0, 0) directly here,
      // synchronously -- confirmed NOT to work on-device. Root cause:
      // window.makcScrollLock.unlock() (called from inside closeSheet's
      // own async finish(), on transitionend or its setTimeout fallback,
      // ~200-250ms later) restores the scroll position captured when the
      // sheet opened, firing AFTER this handler had already returned --
      // silently overwriting the scroll-to-top the moment the sheet
      // finished closing. Passing the scroll-to-top as closeSheet's own
      // onClosed callback (see that function's comment) is the fix:
      // it runs from inside finish(), strictly after unlock(), so it
      // wins the race instead of losing it.
      closeSheet(function () {
        window.scrollTo(0, 0);
      });
    });
  }

  // Extracted so the toolbar's clear-all X and the empty state's own
  // "Clear filters" run the identical sequence. The ordering below is
  // load-bearing (see its comments) and was the fix for a real bug, so
  // the second caller reuses it rather than repeating it.
  function clearAllFilters() {
    appliedFilters = new Set();
    // Order matters, and this is the fix for a real bug (surfaced by
    // the 150ms pill colour transition, root cause older than it): the
    // category row must not be unhidden until the active pill is
    // right, or its first painted frame shows whichever pill the
    // observer last marked current against the FILTERED grid, and the
    // transition crossfades from that stale pill to the correct one.
    // So: restore every card, scroll to top, recompute the active pill
    // against that settled geometry, and only then swap the row back.
    applyFiltersToGrid();
    // Same scroll-to-top decision as Apply (see its own comment) --
    // both actions change the visible product set, so both reset
    // position identically. Called directly here, not via closeSheet's
    // onClosed callback: this button lives in the toolbar's own
    // active-filters row (Row 2), not inside the sheet panel itself,
    // and is only ever visible while the sheet is already closed --
    // there's no makcScrollLock unlock() in this flow to race against,
    // so an immediate call is correct and sufficient here.
    window.scrollTo(0, 0);
    // Guarded: assets/makc-menu-toolbar.js only exports this once it
    // has real scroll targets to observe.
    if (window.makcMenuToolbar && window.makcMenuToolbar.refreshActivePill) {
      window.makcMenuToolbar.refreshActivePill();
    }
    syncToolbarUI();
  }

  if (clearAllButton) {
    clearAllButton.addEventListener('click', clearAllFilters);
  }

  // The empty state's own way out. Only present on the Menu page, and
  // only reachable while it is showing, which by definition means
  // filters are active.
  if (emptyStateClear) {
    emptyStateClear.addEventListener('click', clearAllFilters);
  }

  // ---- Drag-to-dismiss -------------------------------------------------

  if (handleRow && window.PointerEvent) {
    var dragging = false;
    var startY = 0;
    var startHeight = 0;

    handleRow.addEventListener('pointerdown', function (event) {
      // The handle row is display:none from 768, so this is unreachable
      // there by pointer -- the guard covers a synthetic event and makes
      // the breakpoint rule explicit in the behaviour, not just the CSS.
      if (isModalLayout()) return;
      dragging = true;
      startY = event.clientY;
      startHeight = panel.getBoundingClientRect().height;
      panel.classList.add('makc-filter-sheet__panel--dragging');
      handleRow.setPointerCapture(event.pointerId);
    });

    handleRow.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var deltaY = Math.max(0, event.clientY - startY);
      panel.style.transform = 'translateY(' + deltaY + 'px)';
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      panel.classList.remove('makc-filter-sheet__panel--dragging');
      var deltaY = Math.max(0, event.clientY - startY);
      if (deltaY > startHeight * DISMISS_THRESHOLD_RATIO) {
        closeSheet();
      } else {
        panel.style.transform = 'translateY(0)';
      }
    }

    handleRow.addEventListener('pointerup', endDrag);
    handleRow.addEventListener('pointercancel', endDrag);
  }
})();
